<div
    [ngClass]="{ 'is-visible': _isVisible }"
    class="container-news"
    id="container-news"
>
    <ng-container *ngIf="_isVisible">
        
        <div class="container-news__header">
            <div class="column top">
                <h1 class="container-news__header__title">
                    {{ 'news' | translate | titlecase }}
                </h1>
                <button (click)="onClickClose()" class="container-news__header__close"></button>
            </div>
        </div>

        <div class="container-news__content">
            <div
                *ngFor="let item of posts; trackBy: trackByPosts"
                class="container-news__content__item"
            >
                <img class="background" [src]="item.image" alt="image">
                <span class="title">
                    {{item.title}}
                </span>
                <p class="description">
                    {{item.description}}
                </p>
                <div class="footer">
                    <a [href]="item.link" target="_blank" class="footer__submit">
                        <span>
                            {{'showMore' | translate}}
                        </span>
                    </a>
                    <span class="footer__date">
                        {{ item.pubDate | date: 'mediumDate' : '' : langauge }}
                    </span>
                </div>
            </div>
        </div>

        <div class="container-news__pagination">
            <button (click)="loadPage(currentPage - 1)" [disabled]="currentPage === 1">
                <span>
                    {{'prevPage'|translate}}
                </span>
            </button>
            <span class="container-news__pagination__page">{{'pageTitle'|translate}} {{ currentPage }} {{'pageOf'|translate}} {{ totalPages }}</span>
            <button (click)="loadPage(currentPage + 1)" [disabled]="currentPage === totalPages">
                <span>
                    {{'nextPage'|translate}}
                </span>
            </button>
        </div>

    </ng-container>
</div>
